export default __webpack_public_path__ + "static/media/share_email.763cfe65.svg";